import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import autosize from 'autosize';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/todo-title';

Component('tr-todo-page-todo-title', {
  mixins: [eventListenerMixin],

  properties: {
    editUrl: String,

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    editing: {
      type: Boolean,
      default: false,
      observer: 'editingChanged',
    },
  },

  connected() {
    this.element = this.querySelector('.todo-title');
    this.textarea = this.querySelector('textarea');

    if (this.textarea) {
      this.listenTo(this.element, 'click', () => { this.editing = true; });
      this.listenTo(this.textarea, {
        keydown: this.handleKeydown.bind(this),
        blur: () => { this.editing = false; },
      });
      autosize(this.textarea);
    } else {
      this.readonly = true;
    }
  },

  handleKeydown(event) {
    if (event.which === 13) {
      event.stopPropagation();
      event.preventDefault();
      this.editing = false;
    }
  },

  editingChanged(editing) {
    if (editing) {
      const { textarea } = this;
      autosize.update(textarea);
      textarea.focus();
      this.originalContent = textarea.value;
    } else {
      this.syncContent();
    }
  },

  syncContent() {
    const { element, textarea, originalContent } = this;
    if (originalContent === textarea.value) return;
    this.disabled = true;

    this.update({ content: textarea.value })
      .then((todo) => {
        element.innerHTML = todo.content;
        this.disabled = false;
        this.namespacedTrigger('titleChange', {
          detail: { todo },
          bubbles: true,
        });
      });
  },

  update(data) {
    return $.ajax({
      url: this.editUrl,
      type: 'patch',
      dataType: 'json',
      data: {
        todos_management: data,
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
